<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <div :class="$style.root">
    <div :class="$style.services">
      <nuxt-img
        src="/img/services/apple-store.svg"
        width="143"
        height="140"
        sizes="sm:100vw md:143px"
        aria-label="apple store"
        placeholder
        loading="lazy"
      />
      <nuxt-img
        src="/img/services/airbnb.svg"
        width="143"
        height="140"
        sizes="sm:100vw md:143px"
        aria-label="airbnb"
        placeholder
        loading="lazy"
      />
      <nuxt-img
        src="/img/services/xbox.png"
        format="webp"
        width="143"
        height="140"
        sizes="sm:100vw md:143px"
        aria-label="xbox"
        placeholder
        loading="lazy"
      />
      <nuxt-img
        src="/img/services/netflix.png"
        format="webp"
        width="143"
        height="140"
        sizes="sm:100vw md:143px"
        aria-label="netflix"
        placeholder
        loading="lazy"
      />
      <nuxt-img
        src="/img/services/ps.svg"
        width="143"
        height="140"
        sizes="sm:100vw md:143px"
        aria-label="ps"
        placeholder
        loading="lazy"
      />
    </div>
    <div :class="$style.wrapper">
      <div :class="[$style.title, $style[`title-${$i18n.locale}`]]">
        {{ t("block.cardsUnlockServices.title") }}
      </div>
      <div :class="$style.desc">
        {{ t("block.cardsUnlockServices.desc_1") }} <br />
        {{ t("block.cardsUnlockServices.desc_2") }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.root {
  @apply rounded-[40px] relative flex flex-col w-full overflow-hidden;
  @apply px-[30px] py-[80px] md:py-10 lg:px-[30px] lg:py-16;
  @apply min-h-[500px] xxs:min-h-[530px];
  @apply bg-neutral-900 text-white;
}

.wrapper {
  @apply w-full mt-auto;
}

.title {
  @apply font-extrabold leading-none mb-5;
  @apply text-[32px] xxs:text-[36px];
  &-en,
&-id,
&-da,
&-et,
&-hu,
&-lt,
&-nb,
&-ro,
&-sl,
&-cs,
&-el,
&-fi,
&-lv,
&-nl,
&-sk,
&-sv,
&-he,
  &-be,
  &-bg,
  &-it,
  &-tr,
  &-ua,
  &-zh,
  &-de,
  &-bg,
  &-ru,
  &-ja,
  &-th,
  &-pl,
  &-hi,
  &-ar,
  &-bn,
  &-ko,
  &-vi,
  &-sw{
    @apply text-[32px] xxs:text-[36px];
  }
  &-ko,
  &-ja {
    @apply leading-[1.2];
  }
  &-zh {
    @apply leading-[1.2];
  }
  &-pt,
  &-fr,
  &-es {
    @apply text-[24px] xxs:text-[30px] 414:text-[32px] lg:text-[28px] xl:text-[32px];
  }
}

.desc {
  @apply text-[15px];
}

.services {
  @apply w-full grid grid-cols-3 gap-[10px] m-auto place-items-center -translate-y-[70%];
  @apply xxs:-translate-y-[58%];
  @apply xs:-translate-y-[50%];
  @apply md:w-8/12 md:scale-[1.2] md:-translate-y-[30%];
  @apply lg:w-full lg:scale-[1] lg:mt-0 lg:-translate-y-[36%];
}
</style>
